export const environment = {
    environment: 'production', 
    apiUrl: 'https://nmafsm-api.azure.chevron.com/api/',
    calSettings: {
        "autoSignIn": true,
        "popupForLogin": false,
        "cacheLocation": "localStorage",
        "instance": "https://login.microsoftonline.com/",
        "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
        "clientId": "0749aea0-300e-4886-8b88-24c4ce8c656b",
        "redirectUri": "https://nmafsm.azure.chevron.com/",
        "oidcScopes": [
            "openid",
            "profile",
            "email",
            "offline_access"
        ],
        // API access scopes
        "apiScopes": [  
            "openid",
            "profile",
            "email",
            "offline_access",
            "https://nmafsm.azure.chevron.com/user_impersonation"
        ],
        "graphScopes": [],
    }
};
